module.exports = __webpack_public_path__ + "assets/5817f5d2afae6d9bed948c749e54c806.png";